import type { GameMeta } from '@gmp/game-sdk';

export const waveCommandMeta = {
  id: 'wave-command',
  name: 'Wave Command',
  tagline: 'One commands the swarm. One holds the line. Then you swap.',
  description:
    'An asymmetric arcade duel. The commander spends energy launching drone formations down five lanes; the defender rides a rail cannon that overheats. Two 90-second legs, roles swapped, identical budgets.',
  minPlayers: 2,
  maxPlayers: 2,
  estimatedMinutes: [3, 5],
  usesMedia: false,
  modes: [{ id: 'duel', name: 'Duel', description: 'Two legs, swap roles at halftime.' }],
  theme: { primary: '#34f5c5', secondary: '#ff4fd8', background: '#060b1f', ink: '#e9fffa' },
  readiness: 'beta',
  genre: 'Asymmetric arcade duel',
  controls: 'touch-action',
  category: 'versus',
  instructions: [
    { icon: 'Sparkles', title: 'Commander: spend energy', body: 'Pick a formation card, then a lane. Energy refills over time. The defender sees each lane light up just before drones arrive.' },
    { icon: 'Hand', title: 'Defender: slide and fire', body: 'Drag along the rail to aim, hold Fire to shoot. Shooting nonstop overheats the cannon. Pulse pushes close drones back twice per leg.' },
    { icon: 'Trophy', title: 'Score', body: 'Defender scores for drones destroyed, commander for drones that land. Decoys land for nothing.' },
    { icon: 'Siren', title: 'Swap at halftime', body: 'Same rules, same budget, roles reversed. Your total across both roles wins.' },
  ],
} satisfies GameMeta;
